import BasicRouterView from "../../../components/BasicRouterView.vue";

const catalogoRoutes = {
  path: "ctl",
  redirect: { name: "salvos" },
  meta: {
    label: "Catalogos",
    icon: "receipt_long",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "catalogo/catalogo-upload",
      name: "catalogo-upload",
      meta: {
        label: "Upload Arquivo",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/UploadArquivos.vue"),
    },
    {
      path: "catalogo/catalogo-listar-editar-criar",
      name: "catalogo-listareditarcriar",
      meta: {
        label: "Criar/Listar/Editar",
        icon: "note_alt",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/CriarListarEditar.vue"),
    },
    {
      path: "catalogo/catalogo-gestao-catalogo-epi/:unidadeId",
      name: "catalogo-gestaocatalogo-epis",
      meta: {
        label: "Gestão Catalogos",
        icon: "note_alt",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/GestaoCatalogo.vue"),
    },
    {
      path: "catalogo/catalogo-gestao-catalogo-epi/:unidadeId",
      name: "catalogo-gestaocatalogo-epis",
      meta: {
        label: "Gestão Catalogos",
        icon: "note_alt",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/GestaoCatalogo.vue"),
    },
    {
      path: "catalogo/catalogo-gestao-catalogo-nao-epis/:unidadeId",
      name: "catalogo-gestaocatalogo-nao-epis",
      meta: {
        label: "Gestão Catalogos",
        icon: "note_alt",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/GestaoCatalogo.vue"),
    },
    {
      path: "catalogo/catalogo-gestao-catalogo-todos-produtos/:unidadeId",
      name: "catalogo-gestaocatalogo-todos-produtos",
      meta: {
        label: "Gestão Catalogos",
        icon: "note_alt",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/GestaoCatalogo.vue"),
    },
    {
      path: "catalogo/catalogo-gestao-catalogo-editar-produto/:produtoId/:unidadeId",
      name: "catalogo-gestaocatalogo-editar-produto",
      meta: {
        label: "Gestão Catalogos",
        icon: "note_alt",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/EditarProduto.vue"),
    },
  ],
};

export default catalogoRoutes;
